import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ItemService } from '../item.service';

@Component({
  selector: 'cc-item-input',
  templateUrl: './item-input.component.html',
  styleUrls: ['./item-input.component.scss']
})
export class ItemInputComponent implements OnInit, OnDestroy {
  @Input() form: FormGroup;
  @Input() placeholder: string;
  @Input() errorMessage: string;

  constructor(private itemService: ItemService) {}

  ngOnInit() {
    this.itemService.addField(this.form, {
      text: ''
    });
    this.form.get('text').markAsTouched();
  }

  ngOnDestroy(): void {
    this.form.removeControl('text');
  }
}
